<template>
    <div class="w-full flex items-center justify-center flex-col cursor-pointer group">
      <div class="flex flex-col justify-center items-center text-center text-gray-suva">
        <div
            @mouseover="isOpen = true"
            @mouseleave="isOpen = false"
            class="relative z-10">
          <button type="button" aria-haspopup="true"
                  @click="isOpen = !isOpen"
                  class="text-black w-full focus:outline-none cursor-pointer select-none transition px-5 flex flex-col text-sm text-center">
            <div class="flex-auto">{{ label }} ({{checkedItems.length}} / {{options.length}})
            </div>
            <div class="w-full flex justify-center">
              <svg width="15" height="11"
                   viewBox="0 0 15 11"
                   class="fill-current transition transform">
                <path
                    d="M822.424915,589.650504 L824.166833,587.936334 C824.363657,587.742646 824.680229,587.745187 824.873917,587.942011 C824.874788,587.942896 824.875656,587.943784 824.87652,587.944675 L829.424805,592.635986 L829.424805,592.635986 L834.085975,587.940559 C834.280521,587.744583 834.597102,587.743424 834.793077,587.93797 C834.793976,587.938862 834.794871,587.939758 834.795763,587.940657 L836.564758,589.72363 C836.757555,589.917951 836.758255,590.231178 836.566329,590.426359 L829.786457,597.32118 C829.592844,597.518077 829.276272,597.520738 829.079376,597.327124 C829.075677,597.323487 829.072035,597.319793 829.068452,597.316043 L822.414125,590.352316 C822.225327,590.154739 822.230132,589.842183 822.424915,589.650504 Z"
                    transform="translate(-822.000000, -587.000000)"
                    fill-rule="evenodd"/>
              </svg>
            </div>
          </button>
          <div v-show="isOpen"
               class="transition absolute inset-x-0 mx-auto top-full max-h-72 z-20 flex flex-col justify-center items-center">
            <div class="bg-red-cardinal overflow-y-auto overflow-x-hidden w-full min-w-52">
              <ul class="flex flex-col text-center text-white text-sm p-4">
                <li class="flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256">
                    <rect width="256" height="256" fill="none"></rect>
                    <polyline v-show="allChecked" points="172 104 113.3 160 84 132" fill="none" stroke="#fff"
                              stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
                    <rect x="40" y="40" width="176" height="176" rx="8" fill="none" stroke="#fff" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="16"></rect>
                  </svg>
                  <button
                      @click="(event) => $emit('all-clicked')"
                      class="w-full text-left block pl-2 py-2 transition hover:text-gray-40 leading-tight">
                    All {{label}}
                  </button>
                </li>

                <li v-for="option in options" :key="option.id" class="flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256">
                    <rect width="256" height="256" fill="none"></rect>
                    <polyline v-show="isChecked(option)" points="172 104 113.3 160 84 132" fill="none" stroke="#fff"
                              stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
                    <rect x="40" y="40" width="176" height="176" rx="8" fill="none" stroke="#fff" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="16"></rect>
                  </svg>
                  <button
                      @click="(event) => $emit('item-clicked', option)"
                      class="w-full text-left block pl-2 py-2 transition hover:text-gray-40 leading-tight">
                    {{ option.title }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'FilterDropdown',
  data() {
    return {
      isOpen: false
    }
  },
  emits: ['item-clicked', 'all-clicked'],
  methods: {
    isChecked: function (option) {
      return this.checkedItems.includes(option.id);
    }
  },
  computed: {
    allChecked: function() {
      return this.checkedItems.length === this.options.length
    }
  },
  props: {
    label: {type: String, required: true},
    options: {
      required: true,
      type: Object
    },
    checkedItems: {
      type: Array
    },
  },
}
</script>